import { render } from "./FormTextarea.vue?vue&type=template&id=0b5597ca&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import "./FormTextarea.vue?vue&type=style&index=0&id=0b5597ca&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5597ca"]])

export default __exports__